import BoltBanner from "./BoltBanner";
import BoltOwnCode from "./BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("./BoltSuperlative"));
const BoltNeed = lazy(() => import("./BoltNeed"));
const BoltDrive = lazy(() => import("./BoltDrive"));
const BoltJourney = lazy(() => import("./BoltJourney"));
const BoltBuild = lazy(() => import("./BoltBuild"));
const BoltForYou = lazy(() => import("./BoltForYou"));
const BoltDevelopement = lazy(() => import("./BoltDevelopement"));
const BoltCustom = lazy(() => import("./BoltCustom"));
const BoltSmart = lazy(() => import("./BoltSmart"));
const BoltWhiteLabel = lazy(() => import("./BoltWhiteLabel"));
const BoltGen = lazy(() => import("./BoltGen"));
const BoltGlobal = lazy(() => import("./BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Bolt Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "bolt Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Bolt Clone App",
  titlePart3: "Is Superlative For Taxi Booking Businesses?",
  description1: "In today’s fast-paced urban landscape, convenience and reliability are key to customer satisfaction, especially when commuting. That’s where the Bolt Clone app by Mobility Infotech stands out as a game-changer. Tailored for the UK’s dynamic taxi booking industry, our advanced clone solution delivers an all-in-one ride-hailing platform that rivals market leaders in function and experience. Whether you're an entrepreneur looking to launch a new taxi business or an established fleet owner ready to digitise operations, our Bolt Clone app offers a seamless blend of technology and usability. From instant ride-matching to driver tracking, automated fare calculations to secure payment gateways, every feature is engineered to offer a streamlined, intuitive experience for passengers and drivers alike.",
  description2: "What makes our solution superlative isn’t just the design or functionality — it's the strategic advantage it gives your business. The app supports custom branding, geo-fencing, surge pricing, promo campaigns, and multilingual support, enabling taxi startups to cater specifically to regional markets across the UK. With scalability built into the core, the Bolt Clone app adapts as your business grows. In a competitive market, being equipped with the right technology sets you apart. Choose Mobility Infotech’s Bolt Clone app—the smarter, faster, and more scalable way to drive your taxi business into the future.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Mobility Infotech offers custom taxi app development solutions tailored to meet the unique needs of various businesses.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch real-time taxi booking services with instant ride-matching, driver tracking, and secure payments. This is ideal for startups or local operators wanting to offer Bolt-like convenience across UK cities.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Encourage eco-friendly, cost-efficient travel with ride-sharing solutions. Our app supports smart matching, split fares, and route optimisation — perfect for urban UK commuters and sustainable transport initiatives.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Offer streamlined, invoice-based travel for businesses. Our corporate taxi solutions allow employee ride management, usage tracking, and admin control, making it ideal for HR departments and enterprise mobility needs.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Customers can hire drivers by the hour or for intercity rides. This model suits tourists, business travellers, and users needing flexibility without fixed destinations.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Cater to high-end clientele with premium car booking features, chauffeur tracking, and personalised experiences. Ideal for hospitality, events, and executive travel services across the UK.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Target budget-conscious and solo commuters with efficient bike taxi services. Perfect for navigating traffic-heavy UK city centres and last-mile delivery integration.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Launch your taxi brand with our customisable, ready-to-deploy white label solutions. Includes your logo, colour scheme, and tailored features for a unique market presence.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Streamline airport pickups and drop-offs with scheduling, flight tracking, and driver alerts. A perfect fit for travel companies and taxi fleets near major UK airports.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Promote green mobility with EV-specific booking apps, charging point integration, and low-emission ride options — supporting the UK’s shift towards sustainable transportation.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Serve passengers with mobility needs through accessible vehicle support, driver assistance features, and booking options that meet UK disability service standards.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with the UK’s",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our next-gen taxi app solutions and watch your business accelerate like never before.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs Across the Board",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Overall Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Increase in Customer Loyalty and Repeat Usage",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Each Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a Bolt-like app? Understanding the operational flow is essential. Here's a streamlined look at how our Bolt Clone App works to ensure seamless service and user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, we integrate the most advanced technologies into your Bolt Clone taxi app to ensure an exceptional user experience, greater security, and efficient fleet operations. Here’s a look at the key innovations we bring:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "Our system uses artificial intelligence to identify the quickest and most efficient routes in real time. This reduces fuel usage, saves time, and improves customer satisfaction by avoiding traffic and delays, which is essential for UK city navigation.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Our IoT-enabled features allow real-time vehicle tracking, maintenance alerts, and safety monitoring. Fleet operators and passengers benefit from accurate trip insights and driver behaviour analytics, ensuring transparency and smoother ride operations.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "24/7 AI-driven chatbots handle bookings, cancellations, queries, and feedback. They provide instant assistance to users while reducing your dependency on manual customer service, enhancing user experience across the board.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "With blockchain integration, we offer transparent and tamper-proof payment processing. Users and drivers enjoy enhanced transaction security, lower fraud risk, improved trust in digital wallets, and fair settlements.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Our intelligent algorithm matches passengers with the most suitable nearby drivers based on location, driver rating, and ride history—improving efficiency, reducing wait time, and ensuring safer, faster pickups for your customers.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Augmented Reality overlays assist drivers with live directions, street recognition, and landmark cues. This leads to improved navigation accuracy, especially in complex urban settings, making every ride smoother and more reliable.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our",
  titlePart2: "Bolt Clone Taxi App",
  titlePart3: "Development",
  description: "Partner with Mobility Infotech to create a robust, scalable, and future-ready Bolt-like taxi app tailored for the UK market. From ride-hailing to real-time tracking and payments, our feature-rich app supports your growth and operational efficiency at every turn.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "Your customers enjoy a seamless experience with an intuitive interface and essential ride features, all backed by modern tech that enhances convenience and trust.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Effortless ride requests with a user-friendly interface built to suit every UK customer—quick, intuitive, and reliable."
      },
      {
        title: "Multiple Payments Options",
        desc: "Accept payments via card, digital wallet, UPI, or cash—flexible and secure for a better checkout experience."
      },
      {
        title: "Ride Sharing Availability",
        desc: "Customers can share live trip details with friends or family for added safety and transparency."
      },
      {
        title: "Schedule a Ride",
        desc: "Allow users to book future rides in advance—perfect for airport runs or early morning commutes."
      },
      {
        title: "Live Driver Tracking",
        desc: "Real-time location tracking helps riders follow their driver’s approach and estimated arrival time on the map."
      },
      {
        title: "Push Notifications",
        desc: "Instant alerts for ride status, driver info, estimated arrival, vehicle details, and promotional offers."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Our driver-focused Bolt clone app empowers your drivers to manage their rides efficiently while ensuring a smooth and profitable journey.",
    boxes: [
      {
        title: "Direct Call",
        desc: "Drivers can call passengers directly from the app to clarify pick-up instructions or coordinate easily."
      },
      {
        title: "Optimised Route Navigation",
        desc: "Smart navigation with live traffic updates and route optimisation using street view and real-time conditions."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Drivers can manage ride status with one tap and follow map directions for accurate pickups and drop-offs."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access help features for routes, payments, and app usage—all in one convenient place."
      },
      {
        title: "Earnings Dashboard",
        desc: "Drivers can view detailed earnings summaries and daily income reports directly in their app."
      },
      {
        title: "In-App Chat",
        desc: "Secure messaging system between drivers and passengers for smooth coordination without needing third-party apps."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "With our centralised and intelligent dispatcher console, you can monitor and manage every trip, vehicle, and driver in real time.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Innovative system automatically assigns the nearest available driver to each booking with minimal delay."
      },
      {
        title: "Booking Management",
        desc: "Track, manage, and dispatch ride requests with real-time visibility and fleet control."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Track every vehicle live on a dynamic map—perfect for dispatchers managing busy city networks."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send updates, task assignments, or emergency alerts to individual drivers or the entire fleet instantly."
      },
      {
        title: "Complete Transaction History",
        desc: "You can access a full record of completed, pending, and cancelled rides per agent, including fares and ride times."
      },
      {
        title: "Smart Route Planning",
        desc: "Advanced route optimisation helps reduce fuel costs and ensure drivers reach passengers faster."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Gain complete control of your Bolt clone taxi app with a powerful admin panel to oversee operations, analytics, and business performance.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Assign or remove drivers based on live passenger demands and service areas with a few clicks."
      },
      {
        title: "In-Depth Analytics",
        desc: "Comprehensive dashboards show ride volume, revenue flow, customer behaviour, and driver performance."
      },
      {
        title: "Integrated Payment Management",
        desc: "Securely process payments and review balances across all transactions through linked gateways."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Create and manage promo codes, discounts, and loyalty campaigns directly from the panel."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Chat in real time with drivers or dispatchers to resolve issues or share instructions instantly."
      },
      {
        title: "Booking Oversight",
        desc: "Monitor, approve, or edit all ride bookings and dispatches via the real-time administrative dashboard."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Custom Taxi App Solutions",
  description: "Whether you're a taxi fleet owner, a travel operator, or a large corporation, we provide scalable, feature-rich taxi booking apps to enhance customer experiences and streamline operations.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Ensure timely employee pickups and drop-offs with centralized scheduling, route optimization, and reporting tools for business transportation.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Run your taxi fleet with smart dispatching, ride analytics, and automated billing to enhance operational efficiency.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Handle high-volume event transport with route planning, live tracking, and efficient scheduling to ensure guests arrive safely and on time.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Track student rides, notify parents, and ensure safety with automated routes and attendance monitoring for schools and educational institutions.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Deliver smooth travel experiences with multi-stop trip management, route planning, and real-time navigation for tourists and guides.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "A taxi app’s revenue goes beyond just completing rides. Here’s how our Bolt Clone App solutions by Mobility Infotech can deliver a high ROI for your business in the UK:",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "The core revenue source is to earn commission on every ride booked through your app.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Boost profits with dynamic pricing during peak hours and special events.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Reports and Analytics",
      desc: "Generate extra income by charging for premium bookings like luxury cars and SUVs.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Set cancellation fees to recover costs when customers cancel rides.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Allow drivers to join your platform, earn commissions per ride, or lease vehicles directly through the app.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Offer advertising space on your app to brands looking to reach your audience, creating an additional revenue stream.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over a decade of experience and the latest technology, Mobility Infotech helps you launch a fully customised Bolt Clone App tailored for the UK market.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Outperform your competition with advanced features integrated into your white-label taxi booking app.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Get your app live in under 3 days and multiply your taxi booking revenue.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Our solution grows with your business—scale locally or internationally without limits.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Effortlessly connect with your existing payment gateways, third-party services, and operational systems.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Customise every feature and design element to match your business needs and brand identity.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Designed for intuitive use, delivering a seamless experience to both drivers and passengers.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Partner with Mobility Infotech to build your ideal Bolt Clone App and reach your business goals with these features:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch directly from the admin panel.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real-time using GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations anytime, anywhere with live dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Access detailed analytics to optimise your service.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Offer multiple payment options with smooth integration.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Enable customers to rate trips and provide feedback instantly.",
    },
  ],
}

const globalData = {
  titlePart1: "Proven Impact from",
  titlePart2: "Our Taxi App ",
  titlePart3: "Development",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Costs",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is Mobility Infotech’s Bolt Clone App?",
    answer: "Mobility Infotech’s Bolt Clone App is a fully customizable, scalable taxi booking solution designed to replicate the best features of Bolt for the UK market.",
  },
  {
    id: "1",
    question: "02. Why should I choose Mobility Infotech for my taxi app development?",
    answer: "With over a decade of experience, Mobility Infotech offers cutting-edge technology, quick deployment, and tailored solutions backed by expert support.",
  },
  {
    id: "2",
    question: "03. How customizable is the Bolt Clone App developed by Mobility Infotech?",
    answer: "Our app can be customized fully—from branding, features, and vehicle types to payment methods and multilingual support to fit your business needs.",
  },
  {
    id: "3",
    question: "04. Does Mobility Infotech provide post-launch support and maintenance?",
    answer: "Yes, we provide continuous app maintenance, updates, and 24/7 customer support to ensure smooth operations and scalability.",
  },
  {
    id: "4",
    question: "05. How quickly can Mobility Infotech deploy the Bolt Clone App?",
    answer: "Our white-label Bolt Clone App can be ready to launch within 3 days, enabling rapid market entry for your taxi business.",
  },
  {
    id: "5",
    question: "06. Can Mobility Infotech’s app integrate with existing business systems?",
    answer: "Yes, we ensure seamless integration with your current payment gateways, dispatch systems, and third-party tools for smooth operations.",
  },
  {
    id: "6",
    question: "07. What advanced technologies does Mobility Infotech use in its Bolt Clone App?",
    answer: "We incorporate AI-powered route optimization, IoT vehicle tracking, blockchain payments, chatbots for support, and AR navigation for enhanced user experience.",
  },
  {
    id: "7",
    question: "08. How does Mobility Infotech ensure the security of the app?",
    answer: "Our app uses secure payment gateways, blockchain technology, and data encryption to protect user information and prevent fraud.",
  },
];

export default function BoltClone() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
